import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";

function CheckCustomerDataStripe({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [customerData, setCustomerData] = useState({});

  const [DbLogs, setDbLogs] = useState([]);
  const [userDetails, setUserDetails] = useState([]);

  const handleSearch = async () => {
    try {
      if (searchMail) {
        let payload = {
          email: searchMail,
        };
        setLoader(true);
        const res = await api.getStripeCustomerData(payload);
        console.log(res);
        if (res?.success) {
          setSubscriptionData(res?.subscriptions || []);
          setInvoiceData(res?.invoices || []);
          setCustomerData(res?.customer || []);
          setDbLogs(res?.dbLogs || []);
          setUserDetails(res?.dbUser || []);

          setLoader(false);
        } else {
          alert("Email does not exist");
          setLoader(false);
        }
      } else {
        alert("Please insert email for search");
      }
    } catch (error) {
      alert("Invalid Email Address");
      setLoader(false);
    }
  };
  const formatDateFromTs = (date) => {
    const stampToDate = new Date(date * 1000);
    let dateTemp = moment(stampToDate).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="payHistoryPage">
          <div className="row">
            {/* Area Chart */}
            <div className="col">
              <div className="row mx-0 drivers-row">
                <div className="col-12   d-flex justify-content-between pr-0 flex-wrap">
                  <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                    User Data From Stripe And DB
                    {/* ({noOfUser}) */}
                  </h4>
                  {/* <a href="#" className="driver-row-link">All</a>
                                 <a href="#" className="driver-row-link">Arbitrators (86)</a>
                                 <a href="#" className="driver-row-link">Mediators (32)</a> */}
                  <div className="searchMadmin">
                    <div className="inputM">
                      <div className="iM">
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input
                          onChange={(e) => setSearchMail(e.target.value)}
                          type="text"
                          placeholder="Search by email..."
                        />
                      </div>
                      <i
                        className="fa-solid fa-magnifying-glass sIcon"
                        onClick={handleSearch}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card sortby-box br-10 border-transparent mt-3">
                <div className="card-header br-10  bg-white border-transparent py-3 ">
                  <h2>User Data From Stripe</h2>
                  {customerData?.email && (
                    <div className="stripeSubsMain">
                      <div className="dataRow">
                        <div className="title">
                          Email: <span>{customerData?.email}</span>
                        </div>
                        <div className="title">
                          Customer ID: <span>{customerData?.id}</span>
                        </div>
                        <div className="title">
                          Next payment due date:{" "}
                          <span>
                            {subscriptionData.length > 0 &&
                              formatDateFromTs(
                                subscriptionData[0]?.current_period_end
                              )}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* table */}
              <Table
                subscriptionData={subscriptionData}
                invoiceData={invoiceData}
                setPage={setPage}
                page={page}
                noOfUser={noOfUser}
                limit={limit}
                adminType={adminType}
              />

              <div className="card sortby-box br-10 border-transparent mt-3">
                <div className="card-header br-10  bg-white border-transparent py-3 ">
                  <h2>User Data From Our System</h2>
                </div>
              </div>
              <TableForLogs dbLogs={DbLogs} />
              <TableForUser data={userDetails} />
            </div>
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
const Table = ({ subscriptionData, invoiceData, setPage }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };
  const formatDateFromTs = (date) => {
    const stampToDate = new Date(date * 1000);
    let dateTemp = moment(stampToDate).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <h3>Subscription</h3>
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col">Subscription ID</th>
                  <th scope="col">Status</th>
                  <th scope="col">Start</th>
                  <th scope="col">End</th>
                  <th scope="col">
                    <div className="w-max">Will cancel</div>
                  </th>
                  <th scope="col">
                    <div className="w-max">Cancel At</div>
                  </th>
                  <th scope="col">Amount</th>
                  {/* <th scope="col" className="">
                    Subscription End
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {subscriptionData.map((item, key) => (
                  <tr key={key}>
                    <td scope="row">{item?.id}</td>
                    <td>
                      {item.status == "active" ? (
                        <div className="badge bg-success">Active</div>
                      ) : (
                        <div className="badge bg-danger">{item.status}</div>
                      )}
                    </td>
                    <td>
                      <div className="dateTool">
                        <div className="fullDate">
                          {item?.current_period_start
                            ? formatDateFromTs(item?.current_period_start)
                            : "-"}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="dateTool">
                        <div className="fullDate">
                          {item?.current_period_end
                            ? formatDateFromTs(item?.current_period_end)
                            : "-"}
                        </div>
                      </div>
                    </td>
                    <td>{item?.cancel_at_period_end ? "YES" : "-"}</td>
                    <td>
                      {item?.canceled_at
                        ? formatDateFromTs(item?.canceled_at)
                        : "-"}
                    </td>
                    <td>
                      {(item.price?.unit_amount || item.plan?.amount) / 100}{" "}
                      {item.price?.currency || item.plan?.currency}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <h3>Invoices</h3>
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col">Invoice ID</th>
                  <th scope="col">Invoice Number</th>
                  <th scope="col">Amount Due</th>
                  <th scope="col">Amount Paid</th>
                  <th scope="col">Status</th>
                  <th scope="col">Payment Attempt</th>
                  <th scope="col">Hosted invoice</th>
                  {/* <th scope="col" className="">
                    Subscription End
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {invoiceData.map((item, key) => (
                  <tr key={key}>
                    <td scope="row">{item?.id}</td>
                    <td>{item.number}</td>
                    <td>{item.amount_due / 100}</td>
                    <td>{item.amount_paid / 100}</td>
                    <td>
                      {item.status == "paid" ? (
                        <div className="badge bg-success">{item.status}</div>
                      ) : (
                        <div className="badge bg-danger">{item.status}</div>
                      )}
                    </td>
                    <td>
                      <div className="dateTool">
                        <div className="fullDate">
                          {formatDateFromTs(item?.created)}
                        </div>
                      </div>
                    </td>
                    <td>
                      <a
                        href={item?.hosted_invoice_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open Invoice
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
const TableForLogs = ({ dbLogs }) => {
  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const formatDateFromTs = (date) => {
    const stampToDate = new Date(date * 1000);
    let dateTemp = moment(stampToDate).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <h3>Subscription Logs</h3>
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col">Email</th>
                  <th scope="col">Subcription Id</th>
                  <th scope="col">Status</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Created At</th>
                  {/* <th scope="col" className="">
                    Subscription End
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {dbLogs.map((item, key) => (
                  <tr key={key}>
                    <td scope="row">{item?.email}</td>
                    <td scope="row">{item?.subscriptionId}</td>
                    <td>
                      {item.status == "success" ? (
                        <div className="badge bg-success">{item?.status}</div>
                      ) : (
                        <div className="badge bg-danger">{item?.status}</div>
                      )}
                    </td>
                    <td scope="row">{item?.amount}</td>
                    <td>
                      <div className="dateTool">
                        <div className="fullDate">
                          {item?.createdAt ? formatDate(item?.createdAt) : "-"}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

const TableForUser = ({ data }) => {
  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const checkSubscription = (nextPayment) => {
    let currentDate = new Date();
    let endDate = new Date(nextPayment);

    if (currentDate < endDate) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <h3>User Detail</h3>

          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Joined At
                  </th>
                  <th scope="col" className="">
                    Name
                  </th>
                  <th scope="col" className="">
                    Email
                  </th>
                  <th scope="col" className="">
                    Phone
                  </th>
                  <th scope="col" className="">
                    country
                  </th>
                  <th scope="col" className="">
                    DOB
                  </th>
                  <th scope="col" className="">
                    Gender
                  </th>
                  <th scope="col" className="">
                    <div className="w-max-c">Email verified</div>
                  </th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </div>
                    </td>
                    <td scope="row" className="d-flex">
                      <div className="table-text-dark w-max-c db">
                        {item?.name}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.email}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.phone ? item?.phone : "-"}
                      </span>
                    </td>

                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.country ? item?.country : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.dob}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.gender}
                      </span>
                    </td>
                    <td>
                      {item?.emailVerified ? (
                        <span className="table-text-dark w-max-c db">
                          verified
                        </span>
                      ) : (
                        <span className="table-text-dark w-max-c db">
                          not verified
                        </span>
                      )}
                    </td>
                    <td>
                      <div className="d-flex ai-center">
                        {item?.subscription && item?.subscription.length > 0 ? (
                          <>
                            {checkSubscription(
                              item?.subscription[0]?.nextPayment
                            ) ? (
                              <button
                                className="makeSubBtn me-2"
                                style={{
                                  background: "green",
                                  color: "#fff",
                                  width: 103.6,
                                }}
                              >
                                Subscribed
                              </button>
                            ) : (
                              <>
                                <button
                                  className="makeSubBtn me-2 "
                                  style={{
                                    background: "red",
                                    color: "#fff",
                                    width: 103.6,
                                  }}
                                >
                                  Expired
                                </button>
                              </>
                            )}
                          </>
                        ) : (
                          "No Subscription"
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckCustomerDataStripe;
